// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CurrencyMinor from "../../../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as CustomSidebar from "../../../library/reuseable-components/CustomSidebar.bs.js";
import * as NewCorePricing from "./NewCorePricing.bs.js";
import * as BaseDetailsForm from "./BaseDetailsForm.bs.js";
import * as SlabDetailsForm from "./SlabsForm/SlabDetailsForm.bs.js";
import * as ConfirmationModal from "../ConfirmationModal.bs.js";
import * as CorePricingPreviewCmp from "./CorePricingPreviewCmp.bs.js";
import * as CorePricingStepperConfig from "./CorePricingStepperConfig.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as ProgressStepperHook$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepperHook.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var modal_close_cross = PricingDashboardAssetsManager.getImage("modal-close.svg");

function NewCorePricingSidebar$CloseModalConfirmation(Props) {
  var isOpen = Props.isOpen;
  var onCancel = Props.onCancel;
  var onSubmit = Props.onSubmit;
  return React.createElement(ConfirmationModal.make, {
              title: "Discard Changes",
              isOpen: isOpen,
              onConfirmCb: onSubmit,
              onCancelCb: onCancel,
              confirm_button_title: "Yes, Discard",
              cancel_button_title: "No, Cancel",
              children: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
            });
}

var CloseModalConfirmation = {
  make: NewCorePricingSidebar$CloseModalConfirmation
};

function getRestrictedDates(campaigns) {
  switch (campaigns.TAG | 0) {
    case /* Live */1 :
        return List.map((function (c) {
                      switch (c.TAG | 0) {
                        case /* Pending */1 :
                        case /* Rejected */2 :
                            return c._0.start_date;
                        case /* Scheduled */0 :
                        case /* Deleted */3 :
                            return c.campaign.start_date;
                        
                      }
                    }), campaigns._0);
    case /* Loading */0 :
    case /* Error */2 :
        return /* [] */0;
    
  }
}

function NewCorePricingSidebar(Props) {
  var active_campaign = Props.active_campaign;
  var campaigns = Props.campaigns;
  var closeSidebar = Props.closeSidebar;
  var match = React.useState(function () {
        return NewCorePricing.initial_state;
      });
  var setFormDetails = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var toggleDiscardModal = match$1[1];
  var stepper_hook = ProgressStepperHook$Catalyst.useStepper(CorePricingStepperConfig.steppers, /* BaseDetail */0, undefined, undefined);
  var match$2 = stepper_hook.active;
  var tmp;
  switch (match$2) {
    case /* BaseDetail */0 :
        tmp = React.createElement(BaseDetailsForm.make, {
              base_details: state.base_details,
              restricted_dates: getRestrictedDates(campaigns),
              active_campaign: active_campaign,
              onNext: (function (base_details) {
                  Curry._1(stepper_hook.setActive, /* SlabDetails */1);
                  Curry._1(stepper_hook.setCompleted, /* BaseDetail */0);
                  return Curry._1(setFormDetails, (function (pre) {
                                return {
                                        base_details: base_details,
                                        slab_details: pre.slab_details
                                      };
                              }));
                }),
              onBack: (function (param) {
                  return Curry._1(toggleDiscardModal, (function (param) {
                                return true;
                              }));
                })
            });
        break;
    case /* SlabDetails */1 :
        tmp = React.createElement(SlabDetailsForm.make, {
              active_slabs: Belt_Option.mapWithDefault(active_campaign, undefined, (function (param) {
                      return param[0].slabs;
                    })),
              submitted_slabs: state.slab_details,
              onNext: (function (slab_details) {
                  Curry._1(stepper_hook.setActive, /* Preview */2);
                  Curry._1(stepper_hook.setCompleted, /* SlabDetails */1);
                  return Curry._1(setFormDetails, (function (pre) {
                                return {
                                        base_details: pre.base_details,
                                        slab_details: slab_details
                                      };
                              }));
                }),
              onBack: (function (param) {
                  Curry._1(stepper_hook.setActive, /* BaseDetail */0);
                  Curry._1(stepper_hook.resetStepper, /* SlabDetails */1);
                  return Curry._1(stepper_hook.resetStepper, /* BaseDetail */0);
                }),
              free_slab_params: {
                free_kms: Belt_Option.mapWithDefault(state.base_details, 0, (function (d) {
                        return d.free_kms;
                      })),
                price_per_min: CurrencyMinor.toBase(Belt_Option.mapWithDefault(state.base_details, 0, (function (d) {
                            return CurrencyMinor.fromBase(CurrencyMajorMinorMapper.currencyToBase(d.free_km_price));
                          })))
              }
            });
        break;
    case /* Preview */2 :
        tmp = React.createElement(CorePricingPreviewCmp.make, {
              active_campaign: active_campaign,
              new_campaign: state,
              onBack: (function (param) {
                  Curry._1(stepper_hook.setActive, /* SlabDetails */1);
                  return Curry._1(stepper_hook.resetStepper, /* SlabDetails */1);
                }),
              onCloseSidebar: closeSidebar
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement(CustomSidebar.make, {
                  is_open: true,
                  on_back_drop_click: (function (param) {
                      return Curry._1(toggleDiscardModal, (function (param) {
                                    return true;
                                  }));
                    }),
                  children: null
                }, React.createElement("div", {
                      className: "c-campaign-details-header"
                    }, "Create Core Campaign"), React.createElement("div", {
                      className: "c-campaign-details-body"
                    }, stepper_hook.steppers_cmp, tmp)), React.createElement(NewCorePricingSidebar$CloseModalConfirmation, {
                  isOpen: match$1[0],
                  onCancel: (function (param) {
                      return Curry._1(toggleDiscardModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  onSubmit: (function (param) {
                      Curry._1(toggleDiscardModal, (function (param) {
                              return false;
                            }));
                      return Curry._1(closeSidebar, undefined);
                    })
                }));
}

var make = NewCorePricingSidebar;

export {
  modal_close_cross ,
  CloseModalConfirmation ,
  getRestrictedDates ,
  make ,
  
}
/* modal_close_cross Not a pure module */
